import React, { useState } from 'react'
import ExportTypes from './exportTypes'
import ExportDisplay from './exportDisplay'

const PDF = "pdf"

const ExportSelector = ({
  exports,
  prefilledEmail,
  ids,
  displayableExports = ["yuman", "yuman_lines", "sales_journal"],
  accountingExport   = null
}) => {
  const [selectedFormat,    setSelectedFormat]    = useState('')
  const [showExportDisplay, setShowExportDisplay] = useState(false)
  const [email,             setEmail]             = useState(prefilledEmail)
  const [exclude,           setExclude]           = useState(true)
  const [mark,              setMark]              = useState(false)

  const exportedCount = accountingExport?.exportedCount || 0
  const showAccounting = !!accountingExport && !!selectedFormat && selectedFormat !== PDF
  const exportableCount = showAccounting && exclude ? ids.length - exportedCount : ids.length

  const onFormatChange = format => {
    setSelectedFormat(format)
    setMark(!!accountingExport?.formats.includes(format))
  }

  const accounting = showAccounting && {
    selectedCount: ids.length,
    exportedCount,
    exportableCount,
    exclude,
    setExclude,
    mark,
    setMark
  }

  return(
    <>
      {
        showExportDisplay &&
        <ExportDisplay 
          email                = {email}
          setEmail             = {setEmail}
          count                = {exportableCount}
          setShowExportDisplay = {setShowExportDisplay}
        /> 
      }
  
      <div className = {`${showExportDisplay ? 'd-none' : ''}`}>
        <ExportTypes 
          exports              = {exports}
          selectedFormat       = {selectedFormat}
          setSelectedFormat    = {onFormatChange}
          accounting           = {accounting}
          setShowExportDisplay = {setShowExportDisplay}
          displayableExports   = {displayableExports}
          email                = {email}
          setEmail             = {setEmail}
        />
      </div>
    </>
  )
}

export default ExportSelector